// Api Manager
import { getApi, postApi, putFileApi } from "../apiManager/ApiManager";

// Get media signed data
export const getMediaSignedData = async (mediaFileId: string) => {
  const apiParams = {
    file_id: mediaFileId,
  };
  const response = await getApi("/v1/file-store/download-request", apiParams);
  if (response.status && response.data) {
    return response.data;
  } else {
    return null;
  }
};

export const generateUploadRequest = async (fileData: File) => {
  try {
    // Request payload
    const apiParams = {
      fileName: fileData.name,
      fileMime: fileData.type,
      fileMeta: fileData,
    };
    const response = await postApi("/v1/file-store/upload-request", apiParams);
    if (response.status && response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error generating upload request:", error);
    return null;
  }
};

// Upload to S3
export const uploadToAWSServer = async (signedUrl: string, file: File) => {
  try {
    if (!file) {
      console.log("No file selected.");
      return false;
    }
    const uploadResult = await putFileApi(signedUrl, file);
    return uploadResult;
  } catch (error) {
    console.error("File upload failed:", error);
    return false;
  }
};
